export default 
[
    {
        id : 1,
        libelle: "BD, (Débuts...)",
          description : "Cette bande dessinée, que j'ai réalisée à l'âge de 15 ans pour le concours télé 'Les visiteurs du mercredi', est complètement originale, textes et dessins. En fait, avec un recul, je la vois comme un repère de mes véritables premiers dessins ou petits tableaux figuratifs qui annoncent un gôut pour la couleur, et une figuration des 'Petites histoires'...",
          annee_debut: 1976,
          annee_fin: 1984,
          peintures: [
              {
                  titre: "Au large de l'île inconnue Page 1",
                  annee: 1976,
                  detail:'crayons couleurs, encre sur papier 29,7 x 21cm',
                  img:  require('./ressources/76gal/76gal01.jpg')
              },
              {
                titre: "Au large de l'île inconnue Page 2",
                annee: 1976,
                detail:'crayons couleurs, encre sur papier 29,7 x 21cm',
                img:  require('./ressources/76gal/76gal02.jpg')
            },
            {
                titre: "Au large de l'île inconnue Page 3",
                annee: 1976,
                detail:'crayons couleurs, encre sur papier 29,7 x 21cm',
                img:  require('./ressources/76gal/76gal03.jpg')
            },
            {
                titre: "Au large de l'île inconnue Page 4",
                annee: 1976,
                detail:'crayons couleurs, encre sur papier 29,7 x 21cm',
                img:  require('./ressources/76gal/76gal04.jpg')
            },
            {
                titre: "Au large de l'île inconnue Page 5",
                annee: 1976,
                detail:'crayons couleurs, encre sur papier 29,7 x 21cm',
                img:  require('./ressources/76gal/76gal05.jpg')
            },
            {
                titre: "Au large de l'île inconnue Page 6",
                annee: 1976,
                detail:'crayons couleurs, encre sur papier 29,7 x 21cm',
                img:  require('./ressources/76gal/76gal06.jpg')
            },
            {
                titre: "Au large de l'île inconnue Page 7",
                annee: 1976,
                detail:'crayons couleurs, encre sur papier 29,7 x 21cm',
                img:  require('./ressources/76gal/76gal07.jpg')
            },
            {
                titre: "Les fébriles aventures de Yorick Page 1",
                annee: 1984,
                detail:'crayons couleurs, encre sur papier 29,7 x 21cm',
                img:  require('./ressources/84gal/84gal36.jpg')
            },
            {
                titre: "Les fébriles aventures de Yorick Page 2",
                annee: 1984,
                detail:'crayons couleurs, encre sur papier 29,7 x 21cm',
                img:  require('./ressources/84gal/84gal37.jpg')
            },
            {
                titre: "Les fébriles aventures de Yorick Page 3",
                annee: 1984,
                detail:'crayons couleurs, encre sur papier 29,7 x 21cm',
                img:  require('./ressources/84gal/84gal38.jpg')
            },
            {
                titre: "Le cuisinier",
                annee: 1983,
                detail:'huile sur toile 20x30cm',
                img:  require('./ressources/83gal/1.jpg')
            },
            {
                titre: "Street Art à Sao bras,Algarve",
                annee: 1983,
                detail:'peinture sur mur',
                img:  require('./ressources/83gal/2.JPG')
            },
            {
                titre: "Street Art à Sao bras,Algarve 2",
                annee: 1983,
                detail:'peinture sur mur',
                img:  require('./ressources/83gal/3.JPG')
            },

            ]
        },
        {
            id : 2,
              libelle: "Atelier libre Josette Vaudou",
              description : "C'est à l'Atelier Josette Vaudou que j'ai véritablement dessiné et peint régulièrement pour le plaisir, dans un espace de liberté, d'épanouissement artistique...Il y avait des thèmes classiques; nature morte, nus, plâtre, paysages..., mais jamais l'enseignement ne m'a semblé pesant, institutionnel... Madame Josette Vaudou a cette qualité rare qui est de respecter les acquis antérieurs à ses cours et d'intégrer avec légèreté et pédagogie ses connaissances... Deux ans de plaisir à dessiner et peindre...",
              annee_debut: 1982,
              annee_fin: 1985,
              peintures: [
                  {
                      titre: 'Lecture et romantisme',
                      annee: 1983,
                      detail:'huile, gouache sur papier 50 x 65cm',
                      img:  require('./ressources/83gal/83gal01.jpg')
                  },
                  {
                      titre: 'Lecture et romantisme',
                      annee: 1983,
                      detail:'gouache sur papier 50 x 65cm',
                      img:  require('./ressources/83gal/83gal03.jpg')
                  },
                  {
                      titre: 'La soupière bleue',
                      annee: 1983,
                      detail:'gouache sur papier 50 x 65cm',
                      img:  require('./ressources/83gal/83gal04.jpg')
                  },
                  {
                      titre: 'Ombrelle et mandoline',
                      annee: 1984,
                      detail:'gouache sur papier 50 x 65cm',
                      img:  require('./ressources/84gal/84gal01.jpg')
                  },
                  {
                      titre: "Dans l'Espace",
                      annee: 1984,
                      detail:'huile sur papier 50 x 65cm - coll.privée',
                      img:  require('./ressources/84gal/84gal10.jpg')
                  },
                  {
                    titre: "Le vendeur nain de journaux",
                    annee: 1984,
                    detail:"huile sur carton 30 x 20cm - coll.privée",
                    img:  require('./ressources/84gal/84gal03.jpg')
                },
                {
                  titre: "Composition au nu agenouillé",
                  annee: 1984,
                  detail:"fusain, huile sur papier 65 x 50cm",
                  img:  require('./ressources/84gal/84gal09.jpg')
              },
              {
                titre: "L'Alpiniste",
                annee: 1983,
                detail:"huile sur carton 30 x 20cm",
                img:  require('./ressources/83gal/83gal02.jpg')
            },
            {
              titre: "Sans titre",
              annee: 1983,
              detail:"fusain sur papier 65 x 50cm",
              img:  require('./ressources/83gal/83gal05.jpg')
          },
          {
            titre: "Le cuisinier",
            annee: 1983,
            detail:"huile sur toile 33 x 24cm",
            img:  require('./ressources/83gal/83gal09.jpg')
        },
        {
          titre: "Sans titre",
          annee: 1983,
          detail:"fusain sur papier 65 x 50cm",
          img:  require('./ressources/83gal/83gal06.jpg')
      },
      {
        titre: "Sans titre",
        annee: 1983,
        detail:"fusain sur papier 65 x 50cm",
        img:  require('./ressources/83gal/83gal07.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1983,
      detail:"fusain sur papier 65 x 50cm",
      img:  require('./ressources/83gal/83gal08.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1983,
      detail:"fusain sur papier 65 x 50cm",
      img:  require('./ressources/83gal/83gal10.jpg')
      },
      {
      titre: "À la recherche d'un mot rare...",
      annee: 1984,
      detail:"fusain sur papier 65 x 50cm",
      img:  require('./ressources/84gal/84gal02.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1984,
      detail:"fusain sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal20.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1984,
      detail:"fusain sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal19.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1984,
      detail:"fusain sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal22.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1984,
      detail:"fusain sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal21.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1984,
      detail:"fusain sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal23.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1984,
      detail:"fusain sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal15.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1984,
      detail:"fusain sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal18.jpg')
      },
      {
      titre: "Nu allongé",
      annee: 1985,
      detail:"fusain, huile sur papier 50 x 65cm",
      img:  require('./ressources/85gal/85gal04.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1984,
      detail:"fusain sur papier 65 x 50cm",
      img:  require('./ressources/84gal/84gal25.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1984,
      detail:"fusain sur papier 65 x 50cm",
      img:  require('./ressources/84gal/84gal24.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1984,
      detail:"fusain sur papier 65 x 50cm",
      img:  require('./ressources/84gal/84gal17.jpg')
      },
      {
      titre: "Sans titre",
      annee: 1984,
      detail:"fusain sur papier 65 x 50cm",
      img:  require('./ressources/84gal/84gal27.jpg')
      },
      {
      titre: "Coquelicots",
      annee: 1984,
      detail:"huile sur toile 28 x 22cm",
      img:  require('./ressources/84gal/84gal26.jpg')
      },
      {
      titre: "La maison adossée à la colline",
      annee: 1984,
      detail:"huile sur toile 65 x 50cm",
      img:  require('./ressources/84gal/84gal29.jpg')
      },
      {
      titre: "Papillons et fleurs des champ",
      annee: 1985,
      detail:"huile sur toile 122 x 103cm",
      img:  require('./ressources/85gal/85gal09.jpg')
      },
      {
      titre: "La maison adossée à la colline",
      annee: 1984,
      detail:"huile sur papier 65 x 50cm",
      img:  require('./ressources/84gal/84gal04.jpg')
      },
      {
      titre: "Sur les toits",
      annee: 1984,
      detail:"huile sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal11.jpg')
      },
      {
      titre: "La Figue-poire",
      annee: 1984,
      detail:"huile sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal06.jpg')
      },
      {
      titre: "Le Samouraï",
      annee: 1984,
      detail:"huile sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal07.jpg')
      },
      {
      titre: "Méditation",
      annee: 1984,
      detail:"huile sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal12.jpg')
      },
      {
       titre: "Une journée à la plage",
      annee: 1985,
      detail:"huile sur papier 50 x 65cm",
      img:  require('./ressources/85gal/85gal10.jpg')
      },
      {
      titre: "Promenade sur le lac",
      annee: 1984,
      detail:"huile sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal05.jpg')
      },
      {
      titre: "Ballade à la campagne",
      annee: 1985,
      detail:"encre sur papier 44 x 54cm",
      img:  require('./ressources/85gal/85gal01.jpg')
      },
      {
      titre: "Maisonnette dans les champs de lavande",
      annee: 1984,
      detail:"huile sur toile 24 x 35cm",
      img:  require('./ressources/84gal/84gal30.jpg')
      },
      {
      titre: "Amphores et poteries",
      annee: 1985,
      detail:"huile sur papier 50 x 65cm",
      img:  require('./ressources/85gal/85gal07.jpg')
      },
      {
      titre: "Au coin du feu...",
      annee: 1984,
      detail:"huile sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal14.jpg')
      },
      {
      titre: "Voulez-vous du café?",
      annee: 1985,
      detail:"huile sur toile 20 x 25cm",
      img:  require('./ressources/85gal/85gal05.jpg')
      },
      {
      titre: "L'enfant rêveur et la fleur de lotus",
      annee: 1985,
      detail:"huile sur toile 70 x 92cm",
      img:  require('./ressources/85gal/85gal08.jpg')
      },
      {
      titre: "Flacons et bouteilles",
      annee: 1984,
      detail:"huile, gouache sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal28.jpg')
      },
      {
      titre: "Composition à la mandoline",
      annee: 1984,
      detail:"gouache, huile sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal08.jpg')
      },
      {
      titre: "Le pique-nique",
      annee: 1984,
      detail:"huile sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal31.jpg')
      },
      {
      titre: "Liberté les oiseaux",
      annee: 1984,
      detail:"huile sur papier 50 x 65cm",
      img:  require('./ressources/84gal/84gal13.jpg')
      },
      {
      titre: "Baigneuse",
      annee: 1985,
      detail:"huile sur toile 46 x 38cm",
      img:  require('./ressources/85gal/85gal02.jpg')
      },
      {
      titre: "Le temps des amours",
      annee: 1985,
      detail:"huile sur papier 50 x 65cm",
      img:  require('./ressources/85gal/85gal06.jpg')
      },
      {
      titre: "Les chats sur le toit",
      annee: 1985,
      detail:"huile sur toile 46 x 38cm",
      img:  require('./ressources/85gal/85gal03.jpg')
      },
      
              ]
          },
          {
            id : 3,
            libelle: "Gravure",
              description : "Quel bonheur de voir son dessin à la pointe sèche sur zinc apparaître à l'envers avec toujours des surprises dans les tons de noirs, gris, blancs!...",
              annee_debut: 1986,
              annee_fin: 1987,
              peintures: [
                  {
                      titre: "Autoportrait aérien",
                      annee: 1986,
                      detail:'gravure 6 x 9cm',
                      img:  require('./ressources/86gal/86gal08.jpg')
                  },
                  {
                    titre: "L'enfant qui se sentait grandir dans le Musée...",
                    annee: 1987,
                    detail:'gravure 18 x 24cm',
                    img:  require('./ressources/87gal/87gal12.jpg')
                },
                {
                    titre: "Le pêcheur de coquillages",
                    annee: 1987,
                    detail:'gravure 18 x 24cm',
                    img:  require('./ressources/87gal/87gal11.jpg')
                },
                {
                    titre: "Paysage-coquillage",
                    annee: 1987,
                    detail:'gravure 18 x 24cm',
                    img:  require('./ressources/87gal/87gal20.jpg')
                },
                {
                    titre: "Autoportrait dans la bibliothèque",
                    annee: 1987,
                    detail:'gravure 17 x 15cm',
                    img:  require('./ressources/87gal/87gal16.jpg')
                },
                {
                    titre: "Autoportrait visionnaire",
                    annee: 1987,
                    detail:'gravure 15 x 10cm',
                    img:  require('./ressources/87gal/87gal21.jpg')
                },
                {
                    titre: "Atmosphère de bord de mer",
                    annee: 1986,
                    detail:'gravure 21 x 16cm',
                    img:  require('./ressources/86gal/86gal04.jpg')
                },
                {
                    titre: "Portrait au coquillage",
                    annee: 1987,
                    detail:'gravure 24 x 18cm',
                    img:  require('./ressources/87gal/87gal19.jpg')
                },
                {
                    titre: "Villégiature pour la lecture...",
                    annee: 1987,
                    detail:'gravure 18 x 24cm',
                    img:  require('./ressources/87gal/87gal18.jpg')
                },
                {
                    titre: "Le chat de l'artiste",
                    annee: 1986,
                    detail:'gravure 9 x 12cm',
                    img:  require('./ressources/86gal/86gal06.jpg')
                },
                {
                    titre: "Maisonnette en Provence",
                    annee: 1987,
                    detail:'gravure 13 x 17cm',
                    img:  require('./ressources/87gal/87gal09.jpg')
                },
                {
                    titre: "Fossile de poisson",
                    annee: 1986,
                    detail:'gravure 10 x 14cm',
                    img:  require('./ressources/86gal/86gal07.jpg')
                },
                {
                    titre: "Le joueur de banjo du métro",
                    annee: 1986,
                    detail:'gravure 14 x 10cm',
                    img:  require('./ressources/86gal/86gal09.jpg')
                },
                {
                    titre: "Les violonistes escrimeurs...",
                    annee: 1986,
                    detail:'gravure 18 x 13cm',
                    img:  require('./ressources/86gal/86gal01.jpg')
                },
                {
                    titre: "La charmeuse",
                    annee: 1987,
                    detail:'gravure 18 x 13cm',
                    img:  require('./ressources/87gal/87gal13.jpg')
                },
                {
                    titre: "La jeune harpiste...",
                    annee: 1987,
                    detail:'gravure 12 x 9cm',
                    img:  require('./ressources/87gal/87gal22.jpg')
                },
                {
                    titre: "Le chat-escargot du Louvre",
                    annee: 1987,
                    detail:'gravure 18 x 24cm',
                    img:  require('./ressources/87gal/87gal15.jpg')
                },
                {
                    titre: "La faucheuse de blé...",
                    annee: 1987,
                    detail:'gravure 18 x 24cm',
                    img:  require('./ressources/87gal/87gal14.jpg')
                },
                {
                    titre: "L'oiseau et le fruit exotique",
                    annee: 1986,
                    detail:'gravure 21 x 27cm',
                    img:  require('./ressources/86gal/86gal05.jpg')
                },
                {
                    titre: "Paysage aérien",
                    annee: 1987,
                    detail:'gravure 13 x 18cm',
                    img:  require('./ressources/87gal/87gal17.jpg')
                },
                {
                    titre: "Le balayeur du jardin du Luxembourg",
                    annee: 1986,
                    detail:'gravure 10 x 7cm',
                    img:  require('./ressources/86gal/86gal02.jpg')
                },
                {
                    titre: "Femme au violon, spirale, oiseaux et petit cheval..",
                    annee: 1986,
                    detail:'gravure 20 x 15cm',
                    img:  require('./ressources/86gal/86gal03.jpg')
                },
                {
                    titre: "L'homme qui dansait avec son cheval...",
                    annee: 1999,
                    detail:'gravure 24 x 18cm',
                    img:  require('./ressources/99gal/99gal67.jpg')
                },
                {
                    titre: "Sauvez les moulins à vent du Portugal !",
                    annee: 1987,
                    detail:'gravure 24 x 18cm',
                    img:  require('./ressources/87gal/87gal10.jpg')
                },
                ]
            },
            {
                id : 4,
                libelle: "Compositions marines",
                  description : "Mes 'Compositions marines' sont le résultat d'une rencontre de la création naturelle du bois (nœuds, nervures) avec l'artiste. Au hasard d'une rue une planche de Batipin m'a inspiré des yeux composés avec les nœuds du bois ainsi que les lagunes marines avec les nervures. Ces yeux peuvent être aussi des bateaux à voile vus d'avion...",
                  annee_debut: 1987,
                  annee_fin: 1988,
                  peintures: [
                      {
                          titre: "Composition marine",
                          annee: 1988,
                          detail:'huile et vernis sur bois 122 x 99cm',
                          img:  require('./ressources/88gal/88gal14.jpg')
                      },
                      {
                        titre: "Composition marine",
                        annee: 1987,
                        detail:'huile et vernis sur bois 62 x 59cm',
                        img:  require('./ressources/87gal/87gal01.jpg')
                    },
                    {
                        titre: "Composition marine",
                        annee: 1988,
                        detail:'huile et vernis sur bois',
                        img:  require('./ressources/88gal/88gal05.jpg')
                    },
                    {
                        titre: "Composition marine",
                        annee: 1988,
                        detail:'huile et vernis sur bois 62 x 50cm',
                        img:  require('./ressources/88gal/88gal13.jpg')
                    },
                    ]
                },
    {
      id : 5,
      libelle: "Musique",
        description : "Je peins souvent en \"Musique\", c'était la moindre des choses de lui consacrer quelques toiles. Les Musiciens sont peints en transparence sur des partitions de musique marouflées sur toile. Ces Musiciens sont habités par les notes de musique pour privilégier le fond à la forme, peu de couleurs...",
        annee_debut: 1988,
        annee_fin: 1989,
        peintures: [
            {
                titre: "Pensées édifiantes d'un fumeur",
                annee: 1988,
                detail:'collage, huile sur toile 130 x 97cm',
                img:  require('./ressources/88gal/88gal03.jpg')
            },
			{
                titre: "Les papillons noirs",
                annee: 1988,
                detail:'collage, huile sur toile 130 x 97cm',
                img:  require('./ressources/88gal/88gal02.jpg')
            },
			{
                titre: "Le Contrebassiste",
                annee: 1989,
                detail:'collage, huile sur toile 130 x 97cm',
                img:  require('./ressources/89gal/89gal01.jpg')
            },
			{
                titre: "Viens près de moi",
                annee: 1988,
                detail:'collage, huile sur toile 130 x 97cm - coll. privée', 
                img:  require('./ressources/88gal/88gal11.jpg')
            },
			{
                titre: "La violoncelliste",
                annee: 1988,
                detail:'collage, huile sur toile 130 x 97cm - coll. privée', 
                img:  require('./ressources/88gal/88gal16.jpg')
            },
			{
                titre: "Le violoncelliste",
                annee: 1988,
                detail:'collage, huile sur toile 130 x 97cm - coll. privée', 
                img:  require('./ressources/88gal/88gal10.jpg')
            },
			{
                titre: "Les violonistes-escrimeurs",
                annee: 1988,
                detail:'collage, huile sur toile 130 x 97cm', 
                img:  require('./ressources/88gal/88gal04.jpg')
            },
			{
                titre: "La jeune harpiste",
                annee: 1988,
                detail:'collage, huile sur toile 130 x 97cm - coll.privée', 
                img:  require('./ressources/88gal/88gal15.jpg')
            },
            {
                titre: "L'accordéoniste",
                annee: 1989,
                detail:'collage, huile sur toile 130 x 97cm - coll.privée', 
                img:  require('./ressources/89gal/1.JPG')
            }
          ]
    },
    {
        id : 6,
        libelle: "Dessins",
          description : "Cette rubrique 'dessins' permet d'insister sur mon gôut intimement lié du dessin avec la peinture, du renouvellement de ma sensibilité du trait, selon les thèmes et inspirations du moment...",
          annee_debut: 1983,
          annee_fin: 1997,
          peintures: [
              {
                  titre: "Sans titre",
                  annee: 1983,
                  detail:'fusain sur papier 65 x 50cm',
                  img:  require('./ressources/83gal/83gal05.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1983,
                  detail:'fusain sur papier 65 x 50cm',
                  img:  require('./ressources/83gal/83gal06.jpg')
              },
              {
                  titre: "À la recherche d'un mot rare...",
                  annee: 1984,
                  detail:'fusain sur papier 50 x 65cm',
                  img:  require('./ressources/84gal/84gal02.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1983,
                  detail:'fusain sur papier 65 x 50cm',
                  img:  require('./ressources/83gal/83gal08.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1983,
                  detail:'fusain sur papier 65 x 50cm',
                  img:  require('./ressources/83gal/83gal07.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1983,
                  detail:'fusain sur papier 65 x 50cm',
                  img:  require('./ressources/83gal/83gal10.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1984,
                  detail:'fusain sur papier 50 x 65cm',
                  img:  require('./ressources/84gal/84gal15.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1984,
                  detail:'fusain sur papier 65 x 50cm',
                  img:  require('./ressources/84gal/84gal17.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1984,
                  detail:'fusain sur papier 65 x 50cm',
                  img:  require('./ressources/84gal/84gal24.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1984,
                  detail:'fusain sur papier 50 x 65cm',
                  img:  require('./ressources/84gal/84gal19.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1984,
                  detail:'fusain sur papier 50 x 65cm',
                  img:  require('./ressources/84gal/84gal18.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1984,
                  detail:'fusain sur papier 50 x 65cm',
                  img:  require('./ressources/84gal/84gal21.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1984,
                  detail:'fusain sur papier 50 x 65cm',
                  img:  require('./ressources/84gal/84gal22.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1984,
                  detail:'fusain sur papier 50 x 65cm',
                  img:  require('./ressources/84gal/84gal23.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1984,
                  detail:'fusain sur papier 50 x 65cm',
                  img:  require('./ressources/84gal/84gal20.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1984,
                  detail:'fusain sur papier 65 x 50cm',
                  img:  require('./ressources/84gal/84gal25.jpg')
              },
              {
                  titre: "Nu allongé",
                  annee: 1985,
                  detail:'fusain, huile sur papier 50 x 65cm',
                  img:  require('./ressources/85gal/85gal04.jpg')
              },
              {
                  titre: "La sirène",
                  annee: 1984,
                  detail:'fusain, huile sur papier 50 x 65cm',
                  img:  require('./ressources/84gal/84gal35.jpg')
              },
              {
                  titre: "Composition au nu agenouillé",
                  annee: 1984,
                  detail:'fusain, huile sur papier 65 x 50cm',
                  img:  require('./ressources/84gal/84gal09.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1997,
                  detail:'encre sur papier 33 x 26cm',
                  img:  require('./ressources/97gal/97gal13.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1997,
                  detail:'encre sur papier 33 x 26cm',
                  img:  require('./ressources/97gal/97gal06.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1997,
                  detail:'encre sur papier 33 x 26cm',
                  img:  require('./ressources/97gal/97gal05.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1997,
                  detail:'encre sur papier 33 x 26cm',
                  img:  require('./ressources/97gal/97gal07.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1997,
                  detail:'encre sur papier 33 x 26cm',
                  img:  require('./ressources/97gal/97gal10.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1997,
                  detail:'encre sur papier 26 x 33cm',
                  img:  require('./ressources/97gal/97gal09.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1997,
                  detail:'encre sur papier 33 x 26cm',
                  img:  require('./ressources/97gal/97gal12.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1997,
                  detail:'encre sur papier 26 x 33cm',
                  img:  require('./ressources/97gal/97gal11.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1997,
                  detail:'encre sur papier 26 x 33cm',
                  img:  require('./ressources/97gal/97gal04.jpg')
              },
              {
                  titre: "Sans titre",
                  annee: 1997,
                  detail:'encre sur papier cartonné 42 x 34cm',
                  img:  require('./ressources/97gal/97gal08.jpg')
              },
              {
                  titre: "Julien à la plage",
                  annee: 1988,
                  detail:'encres sur papier 18 x 24cm - coll.privée',
                  img:  require('./ressources/88gal/88gal06.jpg')
              },
              {
                  titre: "Ballade à la campagne",
                  annee: 1985,
                  detail:'encre sur papier 44 x 54cm',
                  img:  require('./ressources/85gal/85gal01.jpg')
              },
              {
                  titre: "Composition d'intérieur",
                  annee: 1995,
                  detail:'bois brûlé, pastel, vernis 70 x 40cm',
                  img:  require('./ressources/95gal/95gal03.jpg')
              },
              {
                  titre: "La cigale",
                  annee: 1992,
                  detail:'encre sur papier 44 x 54cm',
                  img:  require('./ressources/92gal/92gal02.jpg')
              }
          ]		
  }, 
	 {
      id :7,
      libelle: "Feuilles - Coeur",
        description : "La première faite en 1992 est la plus réaliste pour devenir par la suite une \"Feuille-Cœur\" symbole d'une sensibilité pour l'écologie. Cette Feuille-Cœur vibre et reste en tension avec le format du cadre pour s'en libérer de temps en temps. Peinte sur toile préablement marouflée de papier de soie froissé, elle a eu une période intitulée \"Les pluies Acides ou les Feuilles qui pleurent\", très critique à propos de la pollution, prétexte aussi artistique pour jouer avec l'aléatoire des coulures. Une période plus optimiste a suivi avec les \"Feuilles-Cœur\", peintes sur Altuglas pour donner une impression vitrail, lumineuse, tonique, optimiste... Avec ces Feuilles plus \"décoratives\" le combat pour l'écologie n'est pas pour autant abandonné! ...",
        annee_debut: 1992,
        annee_fin: 1998,
        peintures: [
            {
                titre: "La Naturelle",
                annee: 1992,
                detail:'huile sur toile 130 x 97cm',
                img:  require('./ressources/92gal/92gal01.jpg')
            },
            {
                titre: "L'AMAZONIENNE",
                annee: 1997,
                detail:'huile sur toile 130 x 97cm',
                img:  require('./ressources/97gal/97gal01.jpg')
            },
			{
                titre: "Feuille d'or",
                annee: 1996,
                detail:'huile sur toile marouflée de papier de soie 130 x 97cm',
                img:  require('./ressources/96gal/96gal06.jpg')
            },
			{
                titre: "Le poumon de la forêt...",
                annee: 1996,
                detail:'huile sur toile 130 x 97cm',
                img:  require('./ressources/96gal/96gal05.jpg')
            },
			{
                titre: "Le cœur qui saigne...",
                annee: 1996,
                detail:'huile sur toile 61 x 50cm - coll.privée',
                img:  require('./ressources/96gal/96gal04.jpg')
            },
			{
                titre: "L'outremer",
                annee: 1996,
                detail:'huile, pigments sur toile 73 x 50cm - coll.privée',
                img:  require('./ressources/96gal/96gal07.jpg')
            },
			{
                titre: "La clair-obscur",
                annee: 1997,
                detail:'huile sur toile 73 x 50cm',
                img:  require('./ressources/97gal/97gal21.jpg')
            },
			{
                titre: "La crépusculaire",
                annee: 1997,
                detail:'huile sur carton 73 x 50cm',
                img:  require('./ressources/97gal/97gal24.jpg')
            },
			{
                titre: "La calcinée",
                annee: 1997,
                detail:'huile sur papier kraft marouflée sur toile 130 x 97cm',
                img:  require('./ressources/97gal/97gal22.jpg')
            },
			{
                titre: "La Pollockienne",
                annee: 1998,
                detail:'papier de soie, huile sur toile 41 x 33cm',
                img:  require('./ressources/98gal/98gal12.jpg')
            },
			{
                titre: "Le drapeau blanc...",
                annee: 1997,
                detail:'huile sur papier crépon, soie, marouflés sur toile 130 x 97cm',
                img:  require('./ressources/97gal/97gal20.jpg')
            },
			{
                titre: "Colibri, pansements et drapeau blanc",
                annee: 1997,
                detail:'huile sur toile 195 x 130cm',
                img:  require('./ressources/97gal/97gal23.jpg')
            },
			{
                titre: "La crucifiée",
                annee: 1998,
                detail:'papier acrylique sur toile 41 x 33cm',
                img:  require('./ressources/98gal/98gal13.jpg')
            },
			{
                titre: "La somnambule",
                annee: 1998,
                detail:'affiche arrachée et détournée 146 x 97cm',
                img:  require('./ressources/98gal/98gal11.jpg')
            },
			{
                titre: "La bohème pour le génie",
                annee: 1999,
                detail:'affiche détournée, collages 73 x 60cm',
                img:  require('./ressources/99gal/99gal64.jpg')
            },
			{
                titre: "La Lichtenstein",
                annee: 1998,
                detail:'affiches, acrylique sur toile 41 x 33cm',
                img:  require('./ressources/98gal/98gal14.jpg')
            },
			{
                titre: "La sophistiquée",
                annee: 1998,
                detail:'acrylique sur toile 41 x 33cm',
                img:  require('./ressources/98gal/98gal15.jpg')
            },
			{
                titre: "L'effet papillon",
                annee: 1999,
                detail:'acrylique sur altuglass 130 x 89cm',
                img:  require('./ressources/99gal/99gal61.jpg')
            },
			// {
            //     titre: "La poule sultane de Ria Formoso",
            //     annee: 1999,
            //     detail:'acrylique sur altuglass 92 x 65cm',
            //     img:  require('./ressources/99gal/99gal56.jpg')
            // },
			{
                titre: "Beautés sous-marines",
                annee: 1999,
                detail:'acrylique sur altuglass 130 x 89cm',
                img:  require('./ressources/99gal/99gal60.jpg')
            },
			{
                titre: "Muet comme une carpe",
                annee: 1999,
                detail:'acrylique sur altuglass 35 x 27cm - coll.privée',
                img:  require('./ressources/99gal/99gal59.jpg')
            },
			{
                titre: "Africa",
                annee: 1999,
                detail:'acrylique sur altuglass 92 x 65cm',
                img:  require('./ressources/99gal/99gal53.jpg')
            },
			{
                titre: "Les flamands roses de Doña Aña",
                annee: 1999,
                detail:'acrylique sur altuglass 92 x 65cm',
                img:  require('./ressources/99gal/99gal55.jpg')
            },
			{
                titre: "Camargue",
                annee: 1999,
                detail:'acrylique sur altuglass 92 x 65cm',
                img:  require('./ressources/99gal/99gal62.jpg')
            },
			{
                titre: "L'hirondelle ne fait plus le printemps",
                annee: 1999,
                detail:'acrylique sur altuglass 92 x 65cm',
                img:  require('./ressources/99gal/99gal54.jpg')
            },
			{
                titre: "Chouette éclipse",
                annee: 1999,
                detail:'acrylique sur altuglass 92 x 65cm',
                img:  require('./ressources/99gal/99gal52.jpg')
            },
			{
                titre: "Le repos de l'ours blanc",
                annee: 1999,
                detail:'acrylique sur altuglass 92 x 65cm',
                img:  require('./ressources/99gal/99gal63.jpg')
            },
			{
                titre: "Petit à petit l'oiseau fait son nid",
                annee: 1999,
                detail:'acrylique sur altuglass 35 x 27cm',
                img:  require('./ressources/99gal/99gal58.jpg')
            },
			{
                titre: "La succinte",
                annee: 1999,
                detail:'acrylique sur carton et altuglass 35 x 27cm - coll.privée ',
                img:  require('./ressources/99gal/99gal57.jpg')
            },
		]
	 },

{
    id : 8,
    libelle: "Alu découpé - Sculpture - bois",
      description : "Le bois brûlé est une technique que j'aime beaucoup pour son côté spontané et définitif, avec des tonalités de bruns clair-osbcurs rappelant les tons chauds de Rembrandt. Ce sont souvent des supports de récupération tels que des cartons ondulés d'emballage...",
      annee_debut: 1991,
      annee_fin: 2001,
      peintures: [
          {
              titre: "La tentation de la musique",
              annee: 1992,
              detail:'aluminium découpé et peint sur bois 41 x 30cm',
              img:  require('./ressources/92gal/92gal05.jpg')
          },
          {
            titre: "L'ange musicien",
            annee: 1991,
            detail:'aluminium découpé et peint sur bois 58 x 54cm',
            img:  require('./ressources/91gal/91gal06.jpg')
        },
        {
            titre: "L'aquarium au poisson rouge",
            annee: 1992,
            detail:'huile sur "boîte à film" 50cm',
            img:  require('./ressources/92gal/92gal11.jpg')
        },
        {
            titre: "Le saxo le chat noir",
            annee: 1995,
            detail:'aluminium découpé et peint 50 x 50cm',
            img:  require('./ressources/95gal/95gal04.jpg')
        },
        {
            titre: "Visions",
            annee: 1987,
            detail:'Lamelles de cuivre pliées 16 x 10cm',
            img:  require('./ressources/sgal/s87ga01.jpg')
        },
        {
            titre: "L'oiseau du peintre",
            annee: 1990,
            detail:'fil de fer 70 x 75cm',
            img:  require('./ressources/sgal/s90ga01.jpg')
        },
        {
            titre: "L'oiseau rare",
            annee: 1992,
            detail:'fil de fer 75 x 18cm',
            img:  require('./ressources/sgal/s92ga01.jpg')
        },
        {
            titre: "L'oiseau rare",
            annee: 1994,
            detail:'bois polychrome',
            img:  require('./ressources/sgal/s94ga01.jpg')
        },
        {
            titre: "Le scooter",
            annee: 1997,
            detail:'9 x 10 x 3cm',
            img:  require('./ressources/sgal/s97ga01.jpg')
        },
        {
            titre: "Autoportrait",
            annee: 1997,
            detail:'pierre 8 x 8 x 3cm',
            img:  require('./ressources/sgal/s97ga02.jpg')
        },
        {
            titre: "Le petit chien",
            annee: 1997,
            detail:'pierre 10 x 13 x 7cm',
            img:  require('./ressources/sgal/s97ga03.jpg')
        },
        {
            titre: "La main noire",
            annee: 1997,
            detail:'bois 120 x 70cm',
            img:  require('./ressources/sgal/s97ga04.gif')
        },
        {
            titre: "Le rêve d'Icare",
            annee: 1998,
            detail:'terre cuite 18 x 15 x 16cm',
            img:  require('./ressources/sgal/s98ga01.jpg')
        },
        {
            titre: "Le naufragé",
            annee: 1999,
            detail:'terre cuite, bois 25 x 20 x 14cm',
            img:  require('./ressources/sgal/s99ga01.jpg')
        },
        {
            titre: "Lucy lisant",
            annee: 2000,
            detail:'(personnages préhistoriques) terre cuite 21 x 12 x 15cm',
            img:  require('./ressources/sgal/sga0002.jpg')
        },
        {
            titre: "Le cavalier",
            annee: 2000,
            detail:'(personnages préhistoriques) terre cuite 10 x 21 x 6cm',
            img:  require('./ressources/sgal/sga0001.jpg')
        },
        {
            titre: "En attendant le 4ème joueur...",
            annee: 2000,
            detail:'(personnages préhistoriques) terre cuite 10 x 7cm',
            img:  require('./ressources/sgal/sga0003.jpg')
        },
        {
            titre: "La toilette",
            annee: 2000,
            detail:'(personnages préhistoriques) terre cuite 16 x 12cm',
            img:  require('./ressources/sgal/sga0004.jpg')
        },
        {
            titre: "Sculpture en métal",
            annee: 2000,
            detail:'métal 24 x 18 x 23cm',
            img:  require('./ressources/sgal/sga0007.jpg')
        },
        {
            titre: "Le naufragé",
            annee: 2000,
            detail:'céramique, bois 19 x 26 x 14cm',
            img:  require('./ressources/sgal/sga0008.jpg')
        },
        {
            titre: "3 tranches de pastèque",
            annee: 2000,
            detail:'bois, acrylique 20 x 30cm',
            img:  require('./ressources/sgal/sga0005.jpg')
        },
        {
            titre: "Tranche de pastèque",
            annee: 2000,
            detail:'bois, acrylique 20 x 30cm - coll. privée',
            img:  require('./ressources/sgal/sga0006.jpg')
        },
        {
            titre: "Composition point sur le i",
            annee: 1995,
            detail:'huile sur carton brûlé 105 x 96cm',
            img:  require('./ressources/95gal/95gal01.jpg')
        },
        {
            titre: "Composition camarguaise",
            annee: 1996,
            detail:'huile sur carton brûlé 92 x 92cm',
            img:  require('./ressources/96gal/96gal03.jpg')
        },
        {
            titre: "Composition aux noix de coco",
            annee: 1998,
            detail:'huile sur carton brûlé 65 x 75cm',
            img:  require('./ressources/98gal/98gal02.jpg')
        },
        {
            titre: "L'écrivain en villégiature...",
            annee: 1998,
            detail:'acrylique, huile sur carton ondulé, bois 74 x 141cm',
            img:  require('./ressources/98gal/98gal03.jpg')
        },
        {
            titre: "Réflexion sur la liberté",
            annee: 2000,
            detail:'bois brûlé, vernis 150 x 150cm',
            img:  require('./ressources/gal00/gal0025.jpg')
        },
        {
            titre: "Composition d'intérieur",
            annee: 1995,
            detail:'bois brûlé, pastel, vernis 70 x 40cm',
            img:  require('./ressources/95gal/95gal03.jpg')
        },
        {
            titre: "La charmeuse",
            annee: 1988,
            detail:'bois brûlé, huile, vernis sur bois 101 x 60cm',
            img:  require('./ressources/88gal/88gal12.jpg')
        },
        {
            titre: "Compositions aux fleurs nids d'abeilles",
            annee: 2000,
            detail:'carton brûlé, acrylique 121 x 72.5cm',
            img:  require('./ressources/gal00/gal0024.jpg')
        },
        {
            titre: "Le petit déjeuner",
            annee: 1996,
            detail:'bois brûlé, huile 30 x 70cm',
            img:  require('./ressources/96gal/96gal08.jpg')
        },
        {
            titre: "Baignade interdite",
            annee: 1991,
            detail:'bois brûlé, huile sur bois 55 x 95cm',
            img:  require('./ressources/91gal/91gal05.jpg')
        },
        {
            titre: "L'assiette de noix",
            annee: 1999,
            detail:'bois brûlé, vernis 31 x 40cm',
            img:  require('./ressources/99gal/99gal50.jpg')
        },
        {
            titre: "L'âme des grenades...",
            annee: 2001,
            detail:'acrylique sur bois 64 x 85cm',
            img:  require('./ressources/gal01/gal0103.jpg')
        },
        {
            titre: "Autoportrait marin",
            annee: 1992,
            detail:'huile sur bois 54 x 34cm - coll.privée',
            img:  require('./ressources/92gal/92gal09.jpg')
        },
        {
            titre: "Autoportrait au chapeau",
            annee: 1991,
            detail:'bois brûlé, vernis 65 x 60cm',
            img:  require('./ressources/91gal/91gal04.jpg')
        },
        {
            titre: "Les fumeurs",
            annee: 1999,
            detail:'bois brûlé 2 x 62 x 52cm',
            img:  require('./ressources/99gal/99gal51.jpg')
        },
        {
            titre: "Le peintre et la toile blanche",
            annee: 1994,
            detail:'bois brûlé, vernis huile 80 x 55cm',
            img:  require('./ressources/94gal/94gal02.jpg')
        },
        {
            titre: "Vue d'avion",
            annee: 1987,
            detail:'huile sur toile 65 x 81cm',
            img:  require('./ressources/87gal/87gal05.jpg')
        },
        {
            titre: "La vieille barque",
            annee: 1989,
            detail:'encre, huile, lavis sur papier 25 x 30cm - coll.privée',
            img:  require('./ressources/89gal/89gal02.jpg')
        },
        {
            titre: "Nature vivante aux trois citrons et tranche de pastèque",
            annee: 1987,
            detail:'technique mixte 35 x 46cm',
            img:  require('./ressources/87gal/87gal23.jpg')
        },
        {
            titre: "Le bouquet mouvant",
            annee: 1992,
            detail:'bois découpé, huile, encres 78 x 48cm',
            img:  require('./ressources/92gal/92gal10.jpg')
        },
        {
            titre: "Sérénade sur les toits",
            annee: 1991,
            detail:'huile sur carton 92 x 88cm',
            img:  require('./ressources/91gal/91gal08.jpg')
        },
        {
            titre: "La cigale",
            annee: 1992,
            detail:'encre sur papier 44 x 54cm',
            img:  require('./ressources/92gal/92gal02.jpg')
        },
        {
            titre: "Les deux chevaux blancs",
            annee: 1991,
            detail:'huile, vernis sur carton 95 x 93cm',
            img:  require('./ressources/91gal/91gal07.jpg')
        },
        {
            titre: "Hibou",
            annee: 1991,
            detail:'huile et vernis sur bois 50 x 37cm',
            img:  require('./ressources/91gal/91gal02.jpg')
        },
        {
            titre: "Julien à la plage",
            annee: 1988,
            detail:'encres sur papier 18 x 24cm - coll.privée',
            img:  require('./ressources/88gal/88gal06.jpg')
        },
        {
            titre: "Crépuscule en mer",
            annee: 1991,
            detail:'huile sur toile 75 x 100cm',
            img:  require('./ressources/91gal/91gal01.jpg')
        },
        {
            titre: "La grosse crevette",
            annee: 1987,
            detail:'huile sur toile 50 x 65cm',
            img:  require('./ressources/87gal/87gal07.jpg')
        },
        {
            titre: "Le dauphin",
            annee: 1992,
            detail:'huile sur carton 70 x 60cm - coll.privée',
            img:  require('./ressources/92gal/92gal07.jpg')
        },
        {
            titre: "Le vieux moulin à vent",
            annee: 1990,
            detail:'huile sur bois 61 x 53cm',
            img:  require('./ressources/90gal/90gal02.jpg')
        },
        {
            titre: "Nature vivante au mimosa",
            annee: 1996,
            detail:'huile sur carton 112 x 102cm',
            img:  require('./ressources/93gal/93gal10.jpg')
        },
        {
            titre: "Fragile",
            annee: 1992,
            detail:'huile, pastel sur carton 68 x 60cm',
            img:  require('./ressources/92gal/92gal04.jpg')
        },
        {
            titre: "Poterie aux trois fruits",
            annee: 1993,
            detail:'fusain, vernis sur carton 112 x 102cm',
            img:  require('./ressources/93gal/93gal11.jpg')
        },
        {
            titre: "La tentation du Fado",
            annee: 1993,
            detail:'huile sur carton 102 x 112cm',
            img:  require('./ressources/93gal/93gal13.jpg')
        },
        {
            titre: "Les oiseaux de Cintra",
            annee: 1993,
            detail:'huile sur carton 102 x 112cm',
            img:  require('./ressources/93gal/93gal14.jpg')
        },
        {
            titre: "Paysage en Algarve",
            annee: 1993,
            detail:'huile sur carton 102 x 112cm',
            img:  require('./ressources/93gal/93gal17.jpg')
        },
        {
            titre: "Olhão",
            annee: 1993,
            detail:'huile sur carton 102 x 112cm',
            img:  require('./ressources/93gal/93gal16.jpg')
        },
        {
            titre: "Les trois oranges",
            annee: 1993,
            detail:'huile sur carton 102 x 112cm',
            img:  require('./ressources/93gal/93gal12.jpg')
        },
        {
            titre: "Les cinq citrons",
            annee: 1993,
            detail:'huile sur carton 102 x 112cm',
            img:  require('./ressources/93gal/93gal15.jpg')
        },
        {
            titre: "Paysages volcaniques",
            annee: 1988,
            detail:'polyptyque, huile sur toile 130 x 97cm',
            img:  require('./ressources/88gal/88gal01.jpg')
        },
        {
            titre: "Paysages volcaniques",
            annee: 1994,
            detail:'huile sur plexiglass 50 x 65cm',
            img:  require('./ressources/94gal/94gal03.jpg')
        },
        {
            titre: "Paysages volcaniques",
            annee: 1994,
            detail:'huile sur plexiglass 50 x 65cm',
            img:  require('./ressources/94gal/94gal04.jpg')
        },
        {
            titre: "Pommes et lecture",
            annee: 1991,
            detail:'huile, vernis sur bois 40 x 50cm',
            img:  require('./ressources/91gal/91gal10.jpg')
        },
        {
            titre: "L'envol d'Icare",
            annee: 1990,
            detail:'polyptyque, cire sur bois 145 x 80cm',
            img:  require('./ressources/90gal/90gal01.jpg')
        },
        {
            titre: "Modèle à la cigarette",
            annee: 1992,
            detail:'fusain, pastel sur carton 82 x 64',
            img:  require('./ressources/92gal/92gal08.jpg')
        },
        {
            titre: "Nu au fond bleu",
            annee: 1991,
            detail:'huile sur bois 50 x 40cm',
            img:  require('./ressources/91gal/91gal03.jpg')
        },
        {
            titre: "La tranche de pastèque",
            annee: 1995,
            detail:'huile sur toile 65 x 50cm',
            img:  require('./ressources/95gal/95gal08.jpg')
        },
        {
            titre: "Liberté",
            annee: 1994,
            detail:'huile sur carton 95 x 65cm',
            img:  require('./ressources/94gal/94gal01.jpg')
        },
        {
            titre: "Bouquet au vase bleu",
            annee: 1992,
            detail:'huile, vernis sur bois 58 x 50cm',
            img:  require('./ressources/92gal/92gal06.jpg')
        },
        {
            titre: "Autour du feu de St-Jean"            ,
            annee: 1995,
            detail:'huile sur toile 73 x 50cm',
            img:  require('./ressources/95gal/95ga07a.jpg')
        },
        {
            titre: "Autour du feu de St-Jean",
            annee: 1995,
            detail:'huile sur toile 73 x 50cm',
            img:  require('./ressources/95gal/95ga07c.jpg')
        },
        {
            titre: "Autour du feu de St-Jean",
            annee: 1995,
            detail:'huile sur toile 73 x 50cm',
            img:  require('./ressources/95gal/95ga07b.jpg')
        },
        {
            titre: "Autour du feu de St-Jean",
            annee: 1995,
            detail:'huile sur toile 73 x 50cm',
            img:  require('./ressources/95gal/95ga07d.jpg')
        },
        {
            titre: "La banane et le verre de Sauterne",
            annee: 1998,
            detail:'banane séchée, acrylique sur bois 22 x 39cm',
            img:  require('./ressources/98gal/98gal09.jpg')
        },
        {
            titre: "Météorite sur fond rouge",
            annee: 1998,
            detail:'huile sur toile 35 x 27cm',
            img:  require('./ressources/98gal/98gal17.jpg')
        },
        {
            titre: "La course",
            annee: 1998,
            detail:'acrylique sur carton 27 x 35cm',
            img:  require('./ressources/98gal/98gal16.jpg')
        },
        {
            titre: "Petit chien échappant à une météorite",
            annee: 1998,
            detail:'huile sur carton 36 x 27cm',
            img:  require('./ressources/98gal/98gal16.jpg')
        },
        {
            titre: "Paysage de rêve",
            annee: 1998,
            detail:'acrylique sur toile 81 x 100cm',
            img:  require('./ressources/98gal/98gal08.jpg')
        },
        {
            titre: "Les deux ours",
            annee: 1998,
            detail:'acrylique sur toile 27 x 35cm - coll.privée',
            img:  require('./ressources/98gal/98gal05.jpg')
        },
        {
            titre: "Bord de Marne",
            annee: 1999,
            detail:'acrylique sur isorel 46 x 38cm',
            img:  require('./ressources/99gal/99gal66.jpg')
        },
        {
            titre: "Paysage du bord de Marne",
            annee: 1999,
            detail:'acrylique sur bois 61 x 81cm',
            img:  require('./ressources/99gal/99gal49.jpg')
        },
        {
            titre: "Paysage du Sud",
            annee: 2001,
            detail:'acrylique sur carton 57 x 66cm',
            img:  require('./ressources/gal01/gal0102.jpg')
        },
        {
            titre: "Paysage-seau",
            annee: 2000,
            detail:'acrylique sur seau transparent 22 x 57cm',
            img:  require('./ressources/gal00/gal0028.jpg')
        },
        {
            titre: "Paysage à la colline de coquelicots",
            annee: 2000,
            detail:'13 x 153cm',
            img:  require('./ressources/gal00/gal0027.jpg')
        },
        {
            titre: "Paysage lunaire",
            annee: 2000,
            detail:'13 x 174cm',
            img:  require('./ressources/gal00/gal0026.jpg')
        },
        {
            titre: "Le verre de la passion",
            annee: 2001,
            detail:'acrylique sur bois et carton brûlé 71 x 80cm',
            img:  require('./ressources/gal01/gal0108.jpg')
        },
        {
            titre: "L'oiseau de malheur",
            annee: 2001,
            detail:'acrylique sur bois et carton brûlé 62 x 80cm',
            img:  require('./ressources/gal01/gal0110.jpg')
        },
        ]
    },
    {
        id : 9,
        libelle: "Portraits",
          description : "Des portraits de personnalités célèbres ou pas, accoudées à une table de bar, café, pub, sirotant un verre et devenant poètes le temps d'une soirée. Des portraits peints volontairement de traits et couleurs débridés comme sont souvent les conversations les nuits de Fête! ...",
          annee_debut: 1982,
          annee_fin: 2006,
          peintures: [
            {
                titre: "L'amoureuse",
                annee: 1997,
                detail:'huile sur toile 66 x 55cm',
                img:  require('./ressources/97gal/97gal14.jpg')
            },
            {
                titre: "La coupe de champagne",
                annee: 1997,
                detail:'technique mixte sur toile 81 x 65cm',
                img:  require('./ressources/97gal/97gal28.jpg')
            },
            {
                titre: "Le rendez-vous au Doobies",
                annee: 1997,
                detail:'technique mixte sur toile 81 x 65cm',
                img:  require('./ressources/97gal/97gal17.jpg')
            },
            {
                titre: "La femme de Picasso",
                annee: 1997,
                detail:'huile sur toile 65 x 54cm',
                img:  require('./ressources/97gal/97gal16.jpg')
            },
            {
                titre: "Black and White blues",
                annee: 1997,
                detail:'huile sur toile 66 x 55cm',
                img:  require('./ressources/97gal/97gal15.jpg')
            },
            {
                titre: "Black is beautiful",
                annee: 1997,
                detail:'huile sur toile 55 x 46cm',
                img:  require('./ressources/97gal/97gal18.jpg')
            },
            {
                titre: "L'attente",
                annee: 1997,
                detail:'technique mixte sur toile 46 x 55cm',
                img:  require('./ressources/97gal/97gal25.jpg')
            },
            {
                titre: "Doux baiser sur la nuque",
                annee: 1997,
                detail:'technique mixte sur toile 54 x 65cm',
                img:  require('./ressources/97gal/97gal27.jpg')
            },
            {
                titre: "Portrait à la coupe de champagne",
                annee: 1999,
                detail:'huile sur carton 78 x 67cm',
                img:  require('./ressources/99gal/99gal65.jpg')
            },
            {
                titre: "La tête dans les étoiles",
                annee: 1998,
                detail: 'huile et vernis sur bois 70 x 60cm',
                img:  require('./ressources/98gal/98gal10.jpg')
            },
            {
                titre:  "L'écrivain",
                annee: 1997,
                detail: 'technique mixte sur toile 81 x 100cm',
                img:  require('./ressources/97gal/97gal26.jpg')
            },
            {
                titre:  "Autoportrait",
                annee: 1997,
                detail: "pochoir à l'aréosol sur les murs de Paris 60 x 45cm",
                img:  require('./ressources/97gal/97gal19.jpg')
            },
            {
                titre:  "Le funambule",
                annee: 1982,
                detail: "aérosol, huile sur papier 50 x 65cm",
                img:  require('./ressources/82gal/82gal01.jpg')
            },
            {
                titre:  "L'Alpiniste",
                annee: 1983,
                detail: "huile sur carton 30 x 20cm",
                img:  require('./ressources/83gal/83gal02.jpg')
            },
            {
                titre:  "Mademoiselle Chang",
                annee: 1982,
                detail: "huile sur toile 30 x 20cm - coll.privée",
                img:  require('./ressources/82gal/82gal02.jpg')
            },
            {
                titre:  "Madame Haranger",
                annee: 1983,
                detail: "feutre sur papier 30 x 20cm - coll.privée",
                img:  require('./ressources/83gal/83gal12.jpg')
            },
            {
                titre:  "Le vendeur nain de journaux",
                annee: 1984,
                detail: "huile sur carton 30 x 20cm - coll.privée",
                img:  require('./ressources/84gal/84gal03.jpg')
            },
            {
                titre: "Composition au nu agenouillé",
                annee: 1984,
                detail: "fusain, huile sur papier 65 x 50cm",
                img:  require('./ressources/84gal/84gal09.jpg')
            },
            {
                titre: "La danseuse",
                annee: 1984,
                detail: "huile sur papier 65 x 50cm",
                img:  require('./ressources/84gal/84gal27.jpg')
            },
            {
                titre: "Sans titre",
                annee: 1984,
                detail: "huile sur papier 65 x 50cm",
                img:  require('./ressources/84gal/84gal24.jpg')
            },
            {
                titre: "Sans titre",
                annee: 1984,
                detail: "fusain sur papier 50 x 65cm",
                img:  require('./ressources/84gal/84gal19.jpg')
            },
            {
                titre: "La sirène",
                annee: 1984,
                detail: "huile sur papier 50 x 65cm",
                img:  require('./ressources/84gal/84gal35.jpg')
            },
            {
                titre: "Baigneuse",
                annee: 1985,
                detail: "huile sur toile 46 x 38cm",
                img:  require('./ressources/85gal/85gal02.jpg')
            },
            {
                titre: "Nu allongé",
                annee: 1985,
                detail: "fusain, huile sur papier 50 x 65cm",
                img:  require('./ressources/85gal/85gal04.jpg')
            },
            {
                titre: "Sans titre",
                annee: 1983,
                detail:"fusain sur papier 65 x 50cm",
                img:  require('./ressources/83gal/83gal05.jpg')
            },
            {
              titre: "Le cuisinier",
              annee: 1983,
              detail:"huile sur toile 33 x 24cm",
              img:  require('./ressources/83gal/83gal09.jpg')
          },
          {
            titre: "Sans titre",
            annee: 1983,
            detail:"fusain sur papier 65 x 50cm",
            img:  require('./ressources/83gal/83gal06.jpg')
        },
        {
            titre: "Sans titre",
            annee: 1984,
            detail:"fusain sur papier 65 x 50cm",
            img:  require('./ressources/84gal/84gal17.jpg')
        },
        {
            titre: "Le Samouraï",
            annee: 1984,
            detail:"huile sur papier 50 x 65cm",
            img:  require('./ressources/84gal/84gal07.jpg')
        },
        {
            titre: "Tranche de pastèque",
            annee: 2000,
            detail:'bois, acrylique 20 x 30cm - coll. privée',
            img:  require('./ressources/sgal/sga0006.jpg')
        },
        {
            titre: "L'envol d'Icare",
            annee: 1990,
            detail:'polyptyque, cire sur bois 145 x 80cm',
            img:  require('./ressources/90gal/90gal01.jpg')
        },
        {
            titre: "Modèle à la cigarette",
            annee: 1992,
            detail:'fusain, pastel sur carton 82 x 64',
            img:  require('./ressources/92gal/92gal08.jpg')
        },
        {
            titre: "Sans titre",
            annee: 1997,
            detail:'encre sur papier 33 x 26cm',
            img:  require('./ressources/97gal/97gal06.jpg')
        },
        {
            titre: "Sans titre",
            annee: 1997,
            detail:'encre sur papier 33 x 26cm',
            img:  require('./ressources/97gal/97gal05.jpg')
        },
        {
            titre: "Sans titre",
            annee: 1997,
            detail:'encre sur papier 26 x 33cm',
            img:  require('./ressources/97gal/97gal04.jpg')
        },
        {
            titre: "Sans titre",
            annee: 1997,
            detail:'encre sur papier 33 x 26cm',
            img:  require('./ressources/97gal/97gal13.jpg')
        },
        {
            titre: "Maternité",
            annee: 1987,
            detail:'huile sur toile 20 x 25cm',
            img:  require('./ressources/87gal/87gal06.jpg')
        },
        {
            titre: "Sans titre",
            annee: 1997,
            detail:'encre sur papier cartonné 42 x 34cm',
            img:  require('./ressources/97gal/97gal08.jpg')
        },
        {
            titre: "Baigneuse azuréenne",
            annee: 1987,
            detail:'huile sur toile 31 x 24cm',
            img:  require('./ressources/87gal/87gal04.jpg')
        },
        {
            titre: "Sans titre",
            annee: 1997,
            detail:'encre sur papier 26 x 33cm',
            img:  require('./ressources/97gal/97gal11.jpg')
        },
        {
            titre: "Autoportrait au caméléon, palette et femme de rêve",
            annee: 1994-1998,
            detail:'acrylique sur papier cartonné 85 x 69cm',
            img:  require('./ressources/98gal/98gal01.jpg')
        },
        {
            titre: "Le livre à la plage",
            annee: 1997,
            detail:'huile sur carton 55 x 47cm',
            img:  require('./ressources/97gal/97gal02.jpg')
        },
        {
            titre: "Le chat faux-escargot",
            annee: 1998,
            detail:'acrylique sur toile 81 x 100cm',
            img:  require('./ressources/98gal/98gal06.jpg')
        },
        {
            titre: "La chaise",
            annee: 1997,
            detail:'huile sur toile 65 x 54cm',
            img:  require('./ressources/97gal/97gal03.jpg')
        },
        {
            titre: "Autoportrait au caméléon, cœur, palette, étoiles filantes...",
            annee: 2001,
            detail:'acrylique sur toile 81 x 65cm - coll.privée',
            img:  require('./ressources/gal01/gal0101.jpg')
        },
        {
            titre: "Nathalie",
            annee: 2001,
            detail:'acrylique sur carton 85 x 80cm',
            img:  require('./ressources/gal01/gal0104.jpg')
        },
        {
            titre: "Autoportrait aux Caméléons et Cœur...",
            annee: 2000,
            detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
            img:  require('./ressources/gal00/gal0001.jpg')
        },
        {
            titre: "Autoportrait bleu",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm',
            img:  require('./ressources/99gal/99gal01.jpg')
        },
        {
            titre: "L'enfant qui rêvait de devenir jazzman...",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
            img:  require('./ressources/99gal/99gal18.jpg')
        },
        {
            titre: "Autoportrait au caméléon",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
            img:  require('./ressources/99gal/99gal31.jpg')
        },
        {
            titre: "Le peintre à la pipe d'argent",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm',
            img:  require('./ressources/99gal/99gal09.jpg')
        },
        {
            titre: "L'homme original attristé...",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
            img:  require('./ressources/99gal/99gal20.jpg')
        },
        {
            titre: "Le cavalier",
            annee: 2000,
            detail:'(personnages préhistoriques) terre cuite 10 x 21 x 6cm',
            img:  require('./ressources/sgal/sga0001.jpg')
        },
        {
            titre: "Le peintre en attente d'idées",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
            img:  require('./ressources/99gal/99gal02.jpg')
        },
        {
            titre: "Sophie",
            annee: 1998,
            detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
            img:  require('./ressources/98gal/98gal04.jpg')
        },
        {
            titre: "En attendant sous l'arbre...",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm',
            img:  require('./ressources/99gal/99gal21.jpg')
        },
        {
            titre: "L'homme aux idées originales",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm',
            img:  require('./ressources/99gal/99gal39.jpg')
        },
        {
            titre: "La voyante aux boules d'argent",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm',
            img:  require('./ressources/99gal/99gal34.jpg')
        },
        {
            titre: "Icare ou l'ange déchu",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm',
            img:  require('./ressources/99gal/99gal41.jpg')
        },
        // {
        //     titre: "Telle une météorite...",
        //     annee: 1999,
        //     detail:'acrylique sur papier cartonné 65 x 50cm',
        //     img:  require('./ressources/99gal/99gal07.jpg')
        // },
        {
            titre: "Contemplation d'une pluie d'étoiles...",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm',
            img:  require('./ressources/99gal/99gal12.jpg')
        },
        {
            titre: "Rescapé du naufrage...",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
            img:  require('./ressources/99gal/99gal24.jpg')
        },
        {
            titre: "La lavandière du Portugal",
            annee: 2000,
            detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
            img:  require('./ressources/gal00/gal0004.jpg')
        },
        {
            titre: "Le conquistador amoureux...",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm',
            img:  require('./ressources/99gal/99gal45.jpg')
        },
        {
            titre: "L'enfant qui se sentait grandir dans le Musée...",
            annee: 1987,
            detail:'gravure 18 x 24cm',
            img:  require('./ressources/87gal/87gal12.jpg')
        },
        {
            titre: "Le peintre aux pensées indiennes",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm',
            img:  require('./ressources/99gal/99gal44.jpg')
        },
        {
            titre: "Le peintre qui broyait du noir...",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm',
            img:  require('./ressources/99gal/99gal04.jpg')
        },
        {
            titre: "Le peintre en attente d'idées",
            annee: 1999,
            detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
            img:  require('./ressources/99gal/99gal02.jpg')
        },
        {
            titre: "L'indien",
            annee: 2000,
            detail:'acrylique sur bois, feuilles 23 x 62cm',
            img:  require('./ressources/gal00/gal0033.jpg')
        },
        {
            titre: "La femme grecque sur fond rouge",
            annee: 1996,
            detail:'huile sur bois 60 x 60cm',
            img:  require('./ressources/96gal/96gal09.jpg')
        },
        {
            titre: "Tango",
            annee: 2000,
            detail:'acrylique sur toile 73 x 60cm - coll.privée',
            img:  require('./ressources/gal00/gal0031.jpg')
        },
        {
            titre: "autoportrait à l'oiseau de feu...",
            annee: 2000,
            detail:'acrylique sur toile 92 x 73cm',
            img:  require('./ressources/gal00/gal0034.jpg')
        },
        {
            titre: "La Suèdoise montmartroise",
            annee: 2001,
            detail:'acrylique sur toile 59 x 59cm',
            img:  require('./ressources/gal01/gal0107.jpg')
        },
        {
            titre: "Rencontre slave",
            annee: 2001,
            detail:'acrylique sur toile 59 x 59cm',
            img:  require('./ressources/gal01/gal0109.jpg')
        },
        {
            titre: "Le rêve de Céline",
            annee: 2001,
            detail:'acrylique sur toile 59 x 59cm',
            img:  require('./ressources/gal01/gal0112.jpg')
        },
        {
            titre: "Katya",
            annee: 2001,
            detail:'acrylique sur toile 59 x 59cm',
            img:  require('./ressources/gal01/gal0111.jpg')
        },
        {titre:"Autoportrait 1",annee:2002, detail:"Photo",img: require('./ressources/gal16/1.jpg')},
        {titre:"Autoportrait 2",annee:2002, detail:"Photo",img: require('./ressources/gal16/2.jpg')},
        {
            titre: "Le vieux peintre",
            annee: 2004,
            detail:'acrylique sur carton 66 x 50cm',
            img:  require('./ressources/gal04/gal0411.jpg')
        },
        {
            titre: "Angelina",
            annee: 2004,
            detail:'acrylique sur carton 66 x 50cm',
            img:  require('./ressources/gal04/gal0412.jpg')
        },
        {
            titre: "Angelina jolie",
            annee: 2004,
            detail:'acrylique sur carton 65 x 50cm',
            img:  require('./ressources/gal04/gal0413.jpg')
        },
        {
            titre: "Angelina jolie",
            annee: 2004,
            detail:'acrylique sur carton 65 x 50cm',
            img:  require('./ressources/gal04/gal0414.jpg')
        },
        {
            titre: "Arnaud, l'architecte",
            annee: 2004,
            detail:'acrylique sur toile 100 x 100cm - coll. privée',
            img:  require('./ressources/gal04/gal0415.jpg')
        },
        {
            titre: "La belle et rare Jennifer",
            annee: 2004,
            detail:'acrylique sur toile 80 x 60cm - coll. privée',
            img:  require('./ressources/gal04/gal0416.jpg')
        },
        {
            titre: "La dormeuse",
            annee: 2004,
            detail:'acrylique sur toile et photo du film: Arts plastiques 70 x 190cm - coll. privée',
            img:  require('./ressources/gal04/gal0417.jpg')
        },
        {
            titre: "Autoportait au caméléon et cœur éclaté...",
            annee: 2005,
            detail:'acrylique sur toile 100 x 100cm',
            img:  require('./ressources/gal05/gal0501.jpg')
        },
        {
            titre: "Modigliani à table",
            annee: 2006,
            detail:'acrylique sur toile 66 x 68cm',
            img:  require('./ressources/gal06/gal0601.jpg')
        },
        {
            titre: "Jennifer for ever",
            annee: 2006,
            detail:'acrylique sur toile 73 x 60cm - coll. privée',
            img:  require('./ressources/gal06/gal0602.jpg')
        },
        {
            titre: "Le peintre-photographe",
            annee: 2006,
            detail:'acrylique sur bois, kodak 1910 73 x 50cm',
            img:  require('./ressources/gal06/gal0603.jpg')
        },
        {
            titre: "Fumeur-non fumeur",
            annee: 2006,
            detail:'bois brûlé 52 x 94cm',
            img:  require('./ressources/gal06/gal0604.jpg')
        },
        ]
    },
    {
        id : 10,
        libelle: "Petites histoires",
          description : "En peignant je dispose souvent des feuilles cartonnées au sol. Celles-ci récupèrent des taches, coulures, pulvérisations d'aréosols, palettes improvisées, pigments. Tous ces petits heureux hasards sont les points de départ de mon inspiration pour les 'Petites Histoires peu ordinaires'...",
          annee_debut: 1998,
          annee_fin: 2001,
          peintures: [
              {
                  titre: "Autoportrait au caméléon",
                  annee: 1999,
                  detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                  img:  require('./ressources/99gal/99gal31.jpg')
              },
              {
                titre: "Autoportrait bleu",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal01.jpg')
            },
            {
                titre: "Le peintre à la pipe d'argent",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal09.jpg')
            },
            {
                titre: "L'enfant qui rêvait de devenir jazzman...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal18.jpg')
            },
            {
                titre: "L'homme original attristé...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal20.jpg')
            },
            {
                titre: "Rescapé du naufrage...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal24.jpg')
            },
            {
                titre: "Autoportrait aux Caméléons et Cœur...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/gal00/gal0001.jpg')
            },
            {
                titre: "ERIKA et les oiseaux...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/gal00/gal0014.jpg')
            },
            {
                titre: "L'antivoyage de l'indien...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal46.jpg')
            },
            {
                titre: "Le conquistador amoureux...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal45.jpg')
            },
            {
                titre: "La voyante aux boules d'argent",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal34.jpg')
            },
            {
                titre: "Le peintre aux pensées indiennes",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal44.jpg')
            },
            {
                titre: "Le peintre qui broyait du noir...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal04.jpg')
            },
            {
                titre: "Le peintre en attente d'idées",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal02.jpg')
            },
            {
                titre: "L'homme aux idées originales",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal39.jpg')
            },
            {
                titre: "Le peintre en attente d'idées",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0003.jpg')
            },
            {
                titre: "Paysage à la Sirène de l'Atlantide...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0002.jpg')
            },
            {
                titre: "La lavandière du Portugal",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/gal00/gal0004.jpg')
            },
            {
                titre: "Le Fado ne mourra pas !...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/gal00/gal0030.jpg')
            },
            {
                titre: "Paysage au bord du Tage",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/gal00/gal0018.jpg')
            },
            {
                titre: "Les amants frôlés par des météorites...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/gal00/gal0015.jpg')
            },
            {
                titre: "L'homme qui cueillait des fleurs la nuit",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0006.jpg')
            },
            {
                titre: "Les saltimbanques et la femme-cœur",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0010.jpg')
            },
            {
                titre: "Peintre en modèle...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0029.jpg')
            },
            {
                titre: "Contemplation d'une pluie d'étoiles...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal12.jpg')
            },
            {
                titre: "Icare ou l'ange déchu",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal41.jpg')
            },
            {
                titre: "La vérité est ailleurs...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0013.jpg')
            },
            {
                titre: "La poule galactique de la création",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal40.jpg')
            },
            {
                titre: "Visions nocturnes",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal19.jpg')
            },
            {
                titre: "L'oiseau qui résista à la tempête",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal42.jpg')
            },
            {
                titre: "L'attente étoilée",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal23.jpg')
            },
            {
                titre: "L'aigle et le petit cheval blanc...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal33.jpg')
            },
            {
                titre: "L'enfant qui se sentait grandir dans le Musée...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0008.jpg')
            },
            // {
            //     titre: "Telle une météorite...",
            //     annee: 1999,
            //     detail:'acrylique sur papier cartonné 65 x 50cm',
            //     img:  require('./ressources/99gal/99gal07.jpg')
            // },
            {
                titre: "En attendant sous l'arbre...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal21.jpg')
            },
            {
                titre: "L'obstacle",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal26.jpg')
            },
            {
                titre: "La femme fragile et les corps célestes",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0012.jpg')
            },
            {
                titre: "Radiographie d'un oiseau rare",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal37.jpg')
            },
            {
                titre: "Le pense bête de l'artiste",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal25.jpg')
            },
            {
                titre: "La sirène qui préférait les caresses des vagues",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0005.jpg')
            },
            {
                titre: "Petit chien échappant de justesse à une météorite",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal35.jpg')
            },
            {
                titre: "Le cavalier",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal30.jpg')
            },
            {
                titre: "Le coq victorieux",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal42.jpg')
            },
            {
                titre: "Alberta 87",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal43.jpg')
            },
            {
                titre: "Sophie",
                annee: 1998,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/98gal/98gal04.jpg')
            },
            {
                titre: "La vieille femme au vélo",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal15.jpg')
            },
            {
                titre: "La penseuse sur la meule de foin",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal32.jpg')
            },
            {
                titre: "L'expo 98...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal48.jpg')
            },
            {
                titre: "Quatre bandes de dauphins",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal14.jpg')
            },
            {
                titre: "La danse des dauphins blancs",
                annee: 2001,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal01/gal0105.jpg')
            },
            {
                titre: "Visions médusées",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal11.gif')
            },
            {
                titre: "Les dauphins amoureux",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal13.jpg')
            },
            {
                titre: "Baignade de nuit interdite",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal28.jpg')
            },
            {
                titre: "Le pêcheur et la vague...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal08.jpg')
            },
            {
                titre: "Le martin-pêcheur grand seigneur...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal17.jpg')
            },
            {
                titre: "Les surfeurs",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal05.jpg')
            },
            {
                titre: "Le calamar géant et la baleine",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal29.jpg')
            },
            {
                titre: "Le crabe et l'oiseau...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal47.jpg')
            },
            {
                titre: "Paysage aérien, hérisson et coccinelle...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/gal00/gal0020.jpg')
            },
            {
                titre: "Paysages - Mirages",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/gal00/gal0022.jpg')
            },
            {
                titre: "Le caméléon",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal06.jpg')
            },
            {
                titre: "Le caméléon",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal27.jpg')
            },
            {
                titre: "Le paon trop bruyant la nuit...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/gal00/gal0007.jpg')
            },
            {
                titre: "La roue du paon...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal22.jpg')
            },
            {
                titre: "Le buffle, la libellule et l'oiseau",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0016.jpg')
            },
            {
                titre: "Horizon enflammé",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0011.jpg')
            },
            {
                titre: "Le point d'exclamation de l'éléphant...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0017.jpg')
            },
            {
                titre: "L'éléphant qui voulait se rafraîchir la mémoire",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0021.jpg')
            },
            {
                titre: "Bataille pour le nid",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/99gal/99gal16.jpg')
            },
            {
                titre: "Combat pour une fleur...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0023.jpg')
            },
            {
                titre: "La pie, la poule et les deux coccinelles...",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal36.jpg')
            },
            {
                titre: "Le prophète, le dragon, la femme et la toupie",
                annee: 1999,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/99gal/99gal38.jpg')
            },
            {
                titre: "Les saltimbanques au cercle de feu...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0019.jpg')
            },
            {
                titre: "La liberté du poisson",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm - coll.privée',
                img:  require('./ressources/gal00/gal0009.jpg')
            },
            {
                titre: "La femme qui offrait spontanément son cœur...",
                annee: 2000,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal00/gal0032.jpg')
            },
            {
                titre: "La sieste",
                annee: 2001,
                detail:'acrylique sur papier cartonné 65 x 50cm',
                img:  require('./ressources/gal01/gal0106.jpg')
            },
            ]
        },
            {
                id : 11,
                libelle: "Paysages rêvés",
                  description : "Des paysages panoramiques entre rêve et réalité, aux couleurs lumineuses, flamboyantes, vibrantes, limpides... Ce sont mes dernières peintures inspirées et peintes en Algarve, ma région natale du Sud du Portugal...",
                  annee_debut: 2002,
                  annee_fin: 2002,
                  peintures: [
                      {
                          titre: "La plage de l'île de Tavira à 7h du matin",
                          annee: 2002,
                          detail:'acrylique sur toile 70 x 190cm',
                          img:  require('./ressources/gal02/gal0201.jpg')
                      },
                      {
                        titre: "La plage de l'île de Tavira à 10h du matin",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0202.jpg')
                    },
                    {
                        titre: "La plage de l'île de Tavira à 13h",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0203.jpg')
                    },
                    {
                        titre: "La plage de l'île de Tavira à 17h",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0204.jpg')
                    },
                    {
                        titre: "Les falaises de Vale do lobo",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0205.jpg')
                    },
                    {
                        titre: "Vale do lobo",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0206.jpg')
                    },
                    {
                        titre: "Les fesses de Santa-luzia",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0207.jpg')
                    },
                    {
                        titre: "La plage de l'île de Faro",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0208.jpg')
                    },
                    {
                        titre: "Le parc naturel de Ria Formosa",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0209.jpg')
                    },
                    {
                        titre: "Les plantes aromatiques sauvages de Ria Formosa",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0210.jpg')
                    },
                    {
                        titre: "Les oiseaux protégés de Ria Formosa",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0211.jpg')
                    },
                    {
                        titre: "Merveilleuse Ria Formosa",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0212.jpg')
                    },
                    {
                        titre: "La route des vacances",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0213.jpg')
                    },
                    {
                        titre: "La montagne en feu",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0214.jpg')
                    },
                    {
                        titre: "Saudades",
                        annee: 2002,
                        detail:'acrylique sur toile 70 x 190cm',
                        img:  require('./ressources/gal02/gal0215.jpg')
                    }
                    ]
                },
                {
                    id : 12,
                    libelle: "Vacances au portugal",
                      description : "Vacances au Portugal, mes azulejos.....",
                      annee_debut: 2004,
                      annee_fin: 2004,
                      peintures: [
                          {
                              titre: "Composition florale",
                              annee: 2004,
                              detail:'acrylique sur carton et toile 90 x 90cm',
                              img:  require('./ressources/gal04/gal0402.jpg')
                          },
                          {
                            titre: "Journée de bronzette",
                            annee: 2004,
                            detail:'acrylique sur carton et toile 90 x 90cm',
                            img:  require('./ressources/gal04/gal0403.jpg')
                        },
                        {
                            titre: "Paysage de campagne et mer",
                            annee: 2004,
                            detail:'acrylique sur carton et toile 90 x 90cm',
                            img:  require('./ressources/gal04/gal0404.jpg')
                        },
                        {
                            titre: "Régate au large de Tavira",
                            annee: 2004,
                            detail:'acrylique sur carton et toile 90 x 90cm',
                            img:  require('./ressources/gal04/gal0405.jpg')
                        },
                        {
                            titre: "Cherchez le bronzage parfait",
                            annee: 2004,
                            detail:'acrylique sur carton et toile 90 x 90cm',
                            img:  require('./ressources/gal04/gal0406.jpg')
                        },
                        {
                            titre: "Gambas et jus de citron",
                            annee: 2004,
                            detail:'acrylique sur carton et toile 90 x 90cm',
                            img:  require('./ressources/gal04/gal0409.jpg')
                        },
                        {
                            titre: "Karting à Almancil",
                            annee: 2004,
                            detail:'acrylique sur carton et toile 90 x 90cm',
                            img:  require('./ressources/gal04/gal0407.jpg')
                        },
                        {
                            titre: "Bord de mer et petits restos",
                            annee: 2004,
                            detail:'acrylique sur carton et toile 90 x 90cm',
                            img:  require('./ressources/gal04/gal0408.jpg')
                        },
                        {
                            titre: "Régate et volley-ball",
                            annee: 2004,
                            detail:'acrylique sur carton et toile 90 x 90cm',
                            img:  require('./ressources/gal04/gal0410.jpg')
                        },
                        ]
                    },
                    {
                        id : 13,
                        libelle: "Visions brûlées",
                          description : "Visions brulées inspirées du papier sulfurisé bruni/brulé  par la chaleur du four lors des cuissons de quiches, pizzas, patisseries...",
                          annee_debut: 2005,
                          annee_fin: 2005,
                          peintures: [
                              {
                                  titre: "Visions brûlées 1",
                                  annee: 2005,
                                  detail:'papier brûlé sur toile 27 x 35cm',
                                  img:  require('./ressources/gal05/gal0503.jpg')
                              },
                              {
                                titre: "Visions brûlées 2",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0504.jpg')
                            },
                            {
                                titre: "Visions brûlées 3",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0505.jpg')
                            },
                            {
                                titre: "Visions brûlées 4",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0506.jpg')
                            },
                            {
                                titre: "Visions brûlées 5",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0507.jpg')
                            },
                            {
                                titre: "Visions brûlées 6",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0508.jpg')
                            },
                            {
                                titre: "Visions brûlées 7",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0509.jpg')
                            },
                            {
                                titre: "Visions brûlées 8",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0510.jpg')
                            },
                            {
                                titre: "Visions brûlées 9",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0511.jpg')
                            },
                            {
                                titre: "Visions brûlées 10",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0512.jpg')
                            },
                            {
                                titre: "Visions brûlées 11",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0513.jpg')
                            },
                            {
                                titre: "Visions brûlées 12",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0514.jpg')
                            },
                            {
                                titre: "Visions brûlées 13",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0515.jpg')
                            },
                            {
                                titre: "Visions brûlées 14",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0516.jpg')
                            },
                            {
                                titre: "Visions brûlées 15",
                                annee: 2005,
                                detail:'papier brûlé sur toile 27 x 35cm',
                                img:  require('./ressources/gal05/gal0517.jpg')
                            },
                            ]
                        },
                        {
                            id : 14 ,
                            libelle: "Portraits rebels",
                              description : "Portraits rebels...",
                              annee_debut: 2006,
                              annee_fin: 2006,
                              peintures: [
                                {titre:"Portraits rebels 1", img: require('./ressources/gal06/gal06001.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 2", img: require('./ressources/gal06/gal06002.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 3", img: require('./ressources/gal06/gal06003.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 4", img: require('./ressources/gal06/gal06004.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 5", img: require('./ressources/gal06/gal06005.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 6", img: require('./ressources/gal06/gal06006.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 7", img: require('./ressources/gal06/gal06007.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 8", img: require('./ressources/gal06/gal06008.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 9", img: require('./ressources/gal06/gal06009.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 10", img: require('./ressources/gal06/gal06010.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 11", img: require('./ressources/gal06/gal06011.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 12", img: require('./ressources/gal06/gal06012.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 13", img: require('./ressources/gal06/gal06013.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 14", img: require('./ressources/gal06/gal06014.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 15", img: require('./ressources/gal06/gal06015.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 16", img: require('./ressources/gal06/gal06016.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 17", img: require('./ressources/gal06/gal06017.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 18", img: require('./ressources/gal06/gal06018.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 19", img: require('./ressources/gal06/gal06019.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 20", img: require('./ressources/gal06/gal06020.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 21", img: require('./ressources/gal06/gal06021.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 22", img: require('./ressources/gal06/gal06022.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 23", img: require('./ressources/gal06/gal06023.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 24", img: require('./ressources/gal06/gal06024.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 25", img: require('./ressources/gal06/gal06025.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 26", img: require('./ressources/gal06/gal06026.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 27", img: require('./ressources/gal06/gal06027.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 28", img: require('./ressources/gal06/gal06028.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 29", img: require('./ressources/gal06/gal06029.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 30", img: require('./ressources/gal06/gal06030.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 31", img: require('./ressources/gal06/gal06031.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 32", img: require('./ressources/gal06/gal06032.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 33", img: require('./ressources/gal06/gal06033.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                                {titre:"Portraits rebels 34", img: require('./ressources/gal06/gal06034.jpg'),annee:2017, detail:"encre sur papier 11 x 8cm"},
                            ]
                        },
                            {
                                id : 15,
                                libelle: "Pixellisme",
                                  description : "Comme il y eut le pointillisme, l'impressionnisme, le cubisme...pourquoi pas le pixellisme?...Je trouve intéressant de destructurer et jouer avec les pixels des images et vidéos numériques. La photo complémentaire à ma peinture avec un média vraiment contemporain et révolutionnaire, tel est ma pensée !",
                                  annee_debut: 2007,
                                  annee_fin: 2012,
                                  peintures: [
                                    {
                                        titre: "Vernissage",
                                        annee: 2007,
                                        detail:'photo/peinture 19 x 26cm - coll. privée',
                                        img:  require('./ressources/gal07/gal0701.jpg')
                                    },
                                    {
                                        titre: "Paysage 1",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0702.jpg')
                                    },
                                    {
                                        titre: "Paysage 2",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0703.jpg')
                                    },
                                    {
                                        titre: "Cocktail",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0704.jpg')
                                    },
                                    {
                                        titre: "a Man",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0705.jpg')
                                    },
                                    {
                                        titre: "a Woman",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0706.jpg')
                                    },
                                    {
                                        titre: "Cadillac",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0707.jpg')
                                    },
                                    {
                                        titre: "Sans titre",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0708.jpg')
                                    },
                                    {
                                        titre: "The car 1",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0709.jpg')
                                    },
                                    {
                                        titre: "The car 2",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0710.jpg')
                                    },
                                    {
                                        titre: "La roue",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0711.jpg')
                                    },
                                    {
                                        titre: "Pixels avec art",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0712.jpg')
                                    },
                                    {
                                        titre: "Man-ideas",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0713.jpg')
                                    },
                                    {
                                        titre: "Visions",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0714.jpg')
                                    },
                                    {
                                        titre: "Paysage 3",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0715.jpg')
                                    },
                                    {
                                        titre: "La dernière cigarette",
                                        annee: 2007,
                                        detail:"photo/peinture",
                                        img:  require('./ressources/gal07/gal0716.jpg')
                                    },
                                    {
                                        titre:"Déesses-mères...",
                                        annee: 2008,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-09.jpg')
                                    },
                                    {
                                        titre:"Modernes avant le modernisme!..",
                                        annee: 2008,
                                        detail:"photo/peinture sur papier - coll. privée",
                                        img:  require('./ressources/gal0809/gal0809-10.jpg')
                                    },
                                    {
                                        titre:"Idoles cycladiques",
                                        annee: 2008,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-11.jpg')
                                    },
                                    {
                                        titre:"Plus de 4500 ans nous séparent!...",
                                        annee: 2008,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-12.jpg')
                                    },
                                    {
                                        titre:"Paysage d'ALGARVE",
                                        annee: 2008,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-05.jpg')
                                    },
                                    {
                                        titre:"Essentielles ABEILLES!!!",
                                        annee: 2008,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-06.jpg')
                                    },
                                    {
                                        titre:"Precious water,eau rare,agua preçiosa",
                                        annee: 2008,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-07.jpg')
                                    },
                                    {
                                        titre:"Ginkgo forte tête...",
                                        annee: 2008,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-08.jpg')
                                    },
                                    {
                                        titre:"Cristiano Ronaldo, simply the best!!!",
                                        annee: 2008,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-01.jpg')
                                    },
                                    {
                                        titre:"Un toit pour tous!!!",
                                        annee: 2008,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-02.jpg')
                                    },
                                    {
                                        titre:"Nous ne sommes pas que des numéros!!!..",
                                        annee: 2008,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-03.jpg')
                                    },
                                    {
                                        titre:"Paysage fleuri da ilha da Madeira",
                                        annee: 2008,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-04.jpg')
                                    },
                                    {
                                        titre:"Paysage nano",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-13.jpg')
                                    },
                                    {
                                        titre:"Paysage-vitrail",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-14.jpg')
                                    },
                                    {
                                        titre:"Pixels big-bang",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-15.jpg')
                                    },
                                    {
                                        titre:"Sciences et avenir",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-16.jpg')
                                    },
                                    {
                                        titre:"Beaux ARTS PLACEBO...",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-17.jpg')
                                    },
                                    {
                                        titre:"El NINO...",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-18.jpg')
                                    },
                                    {
                                        titre:"L'effet papillon...",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-19.jpg')
                                    },
                                    {
                                        titre:"Plus de BIO pour le futur!!!",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-20.jpg')
                                    },
                                    {
                                        titre:"Jour et nuit...",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-21.jpg')
                                    },
                                    {
                                        titre:"La vie en rose...",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-22.jpg')
                                    },
                                    {
                                        titre:"Mère-nature...",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-23.jpg')
                                    },
                                    {
                                        titre:"Préjugés...",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-24.jpg')
                                    },
                                    {
                                        titre:"Precious LIVES!... Nada ne vale la VIDA!... Rien ne vaut la VIE!...",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-25.jpg')
                                    },
                                    {
                                        titre:"WORLD pixels DANCE!...",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-26.jpg')
                                    },
                                    {
                                        titre:"Différences-Contrastes-Beautés-Richesses!...",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-27.jpg')
                                    },
                                    {
                                        titre:"IMAGINATION = SOLUTIONS!...",
                                        annee: 2009,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal0809/gal0809-28.jpg')
                                    },
                                    {
                                        titre:"B est P ollueur",
                                        annee: 2010,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-01.jpg')
                                    },
                                    {
                                        titre:"Des couleurs thérapeutiques!",
                                        annee: 2010,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-02.jpg')
                                    },
                                    {
                                        titre:"Espace Vital !",
                                        annee: 2010,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-03.jpg')
                                    },
                                    {
                                        titre:"Paysage rêvé",
                                        annee: 2010,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-04.jpg')
                                    },
                                    {
                                        titre:"Le rayon vert",
                                        annee: 2010,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-05.jpg')
                                    },
                                    {
                                        titre:"Préjugés et malentendus",
                                        annee: 2010,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-06.jpg')
                                    },
                                    {
                                        titre:"Visions singulières",
                                        annee: 2010,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-07.jpg')
                                    },
                                    {
                                        titre:"Nouveaux languages",
                                        annee: 2010,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-08.jpg')
                                    },
                                    {
                                        titre:"ADN Artistique",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-09.jpg')
                                    },
                                    {
                                        titre:"Horizons incertains",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-10.jpg')
                                    },
                                    {
                                        titre:"Idées colorées",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-11.jpg')
                                    },
                                    {
                                        titre:"Tornade pixéllisée",
                                        annee: 2012,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-12.jpg')
                                    },
                                    {
                                        titre:"La cité Pixellisée",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-13.jpg')
                                    },
                                    {
                                        titre:"La connaissance n'a pas de frontières",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-14.jpg')
                                    },
                                    {
                                        titre:"L'aveuglement religieux",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-15.jpg')
                                    },
                                    {
                                        titre:"Le poid des images",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-16.jpg')
                                    },
                                    {
                                        titre:"L'éléphant sensible",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-17.jpg')
                                    },
                                    {
                                        titre:"Rendez-vous",
                                        annee: 2012,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-18.jpg')
                                    },
                                    {
                                        titre:"Pression excessive à la consommation",
                                        annee: 2012,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-19.jpg')
                                    },
                                    {
                                        titre:"Paysage intriguant",
                                        annee: 2012,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-20.jpg')
                                    },
                                    {
                                        titre:"Paysage tropical",
                                        annee: 2012,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-21.jpg')
                                    },
                                    {
                                        titre:"Pensée constructive",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-22.jpg')
                                    },
                                    {
                                        titre:"Peinture de l'intranquillité",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-23.jpg')
                                    },
                                    {
                                        titre:"Pixels Tsunami",
                                        annee: 2012,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-24.jpg')
                                    },
                                    {
                                        titre:"Portrait printanier",
                                        annee: 2012,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-25.jpg')
                                    },
                                    {
                                        titre:"Deuxième rendez-vous",
                                        annee: 2012,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-26.jpg')
                                    },
                                    {
                                        titre:"Téte en l'air",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-27.jpg')
                                    },
                                    {
                                        titre:"Tolérance indispensable",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-28.jpg')
                                    },
                                    {
                                        titre:"Intemporel",
                                        annee: 2012,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-29.jpg')
                                    },
                                    {
                                        titre:"Affiche DROP by DROP ONU",
                                        annee: 2012,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-30.jpg')
                                    },
                                    {
                                        titre:"Affiche DROP by DROP ONU",
                                        annee: 2012,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-31.jpg')
                                    },
                                    {
                                        titre:"Black graffs",
                                        annee: 2012,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-32.jpg')
                                    },
                                    {
                                        titre:"Créations en ébullition",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-33.jpg')
                                    },
                                    {
                                        titre:"FUKUSHIMA c'est pas du cinéma!",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-34.jpg')
                                    },
                                    {
                                        titre:"Exception saturée",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-35.jpg')
                                    },
                                    {
                                        titre:"Compréhension",
                                        annee: 2011,
                                        detail:"photo/peinture sur papier",
                                        img:  require('./ressources/gal2010/gal2010-36.jpg')
                                    },
                                    {
                                        titre:"Concours ONU",
                                        annee: 2011,
                                        detail:"dessin",
                                        img:  require('./ressources/gal2010/gal2010-37.jpg')
                                    }
                                    ]
                                },
                                {
                                    id : 16,
                                    libelle: "Hommage",
                                      description : "Hommage aux Artistes Libres et victimes des attentats... et à ma mère",
                                      annee_debut: 2015,
                                      annee_fin: 2015,
                                      peintures: [
                                        {titre:"Sans titre",annee:2015, detail:"Acrylique sur toile ,feuilles de tilleul 152x90cm",img: require('./ressources/gal15/1.jpg')},
                                        {titre:"Sans titre",annee:2015, detail:"Acrylique sur toile ,feuilles de tilleul 152x90cm",img: require('./ressources/gal15/2.jpg')},
                                        {titre:"Sans titre",annee:2015, detail:"Acrylique sur toile ,feuilles de tilleul 152x90cm",img: require('./ressources/gal15/3.jpg')},
                                      ]
                                },
                                {
                                    id : 17,
                                    libelle: "Petite Rétrospective au Museu Municipal de Faro",
                                      description : "Petite Rétrospective au Museu Municipal de Faro",
                                      annee_debut: 2016,
                                      annee_fin: 2016,
                                      peintures: [
                                        {titre:"Affiche exposition",annee:2016, detail:"Affiche papier",img: require('./ressources/afficheExpojsg.png')},
                                          
                                        
                                      ],
                                      video:
                                      {
                                          url:"//www.dailymotion.com/embed/video/x454apj"
                                      }
                                },
                                {
                                    id : 18,
                                    libelle: "Dessins au café+cuillère",
                                      description : "Dessins réalisés en Live en terrasses de cafés , entre Paris et l'Algarve",
                                      annee_debut: 2016,
                                      annee_fin: 2018,
                                      peintures: [
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/0.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/1.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/2.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/3.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/4.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/5.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/6.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/7.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/8.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/9.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/10.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/11.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/12.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/13.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/14.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/15.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/16.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/17.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/18.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/19.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/20.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/21.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/22.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/23.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/24.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/25.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/26.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/27.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/28.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/29.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/30.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/31.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/32.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/33.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/34.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/35.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/36.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/37.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/38.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/39.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/40.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/41.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/42.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/43.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/44.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/45.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/46.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/47.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/48.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/49.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/50.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/51.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/52.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/53.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/54.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/55.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/56.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/57.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/58.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/59.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/60.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/61.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/62.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/63.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/64.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/65.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/66.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/67.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/68.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/69.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/70.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/71.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/72.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/73.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/74.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/75.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/76.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/77.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/78.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/79.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/80.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/81.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/82.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/83.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/84.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/85.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/86.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/87.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/88.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/89.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/90.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/91.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/92.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/93.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/94.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/95.jpg')},
                                        {titre:"Dessins terrasses de cafés",annee:2017, detail:"papier/carnet A4 avec du café et petite cuillère",img: require('./ressources/dessins_cafe/96.jpg')},

                                    ]
                                }
                                
                                

]



// WEBPACK FOOTER //
// ./src/Data.js